<mad-main-container>
  <mad-content-header>
    <example-header></example-header>
  </mad-content-header>
  <mad-content-panel-container>
    <mad-content-panel-container-content>
      <p>
        {{ 'news.description' | translate }}
        <a href="https://github.com/porscheinformatik/material-addons/releases">{{ 'news.releaseLink' | translate }}</a>
      </p>
    </mad-content-panel-container-content>
  </mad-content-panel-container>
</mad-main-container>
